import React from 'react';
import CustomizeComponentFactory from '../CustomizeComponentFactory';
import styles from './PageContent.module.less';
import RenderEcmRichText from '../../../components/Text/RenderEcmRichText';

const PageDescription = ({ description, additionalDescriptionContent }) => {
  return (
    <div data-testid="description-content">
      {description && <RenderEcmRichText className={styles.description} content={description} />}
      {additionalDescriptionContent &&
        additionalDescriptionContent.map((item) => {
          return (
            <CustomizeComponentFactory
              ecmContent={item}
              className="customizePageElement"
              key={item.id}
            />
          );
        })}
    </div>
  );
};

export default PageDescription;
